import React from 'react';
import { connect } from 'react-redux';

import { getGuideListFiltered } from './../store/help/selectors';
import MarkableText from './MarkableText';

const HelpTabGuides = props => {
    
    const { guideList, guideItemTitle, search } = props;
    
    return (
        <section className="right-content padding-content">
            
            {search 
                ? <h1 className="title title-search"><span>Search results for:</span> {search}</h1>
                : <h1 className="title">{guideItemTitle}</h1>
            }
            
            <ul className="guide-list">
                {guideList.map(guideItem =>
                    <li key={guideItem.title}>
                        <a className={'guide-item file-icon ' + guideItem.icon}  href={guideItem.url} target="_blanc">
                            <MarkableText html={guideItem.title} mark={search} />
                            <span className="btn btn-light btn-small custom-hover">DOWNLOAD</span>
                        </a>
                    </li>
                )}
            </ul>

        </section>
    );

};

const mapStateToProps = (state, ownProps) => {
    const category = ownProps.match.params.category;
    const search = state.help.search;
    const guideList = getGuideListFiltered(state);
    const catGuideList = !search ? guideList.filter(item => item.category === category) : guideList;
    const guideItemTitle = state.help.guidesCats[category].text;
    return { guideList : catGuideList, guideItemTitle, search };
};

export default connect(mapStateToProps)(HelpTabGuides);


// WEBPACK FOOTER //
// ./src/components/HelpTabGuides.js